// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateCustomOrPartnerModelModal-module__title--2twe5","label":"CreateCustomOrPartnerModelModal-module__label--23SdW"};